import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { ModernNavbar } from '@/components/Landing/ModernNavbar'
import '@/components/Public/PublicPages.css'

const ModernFooter = React.lazy(() => import('@/components/Landing/ModernFooter'))

export const PublicLayout: React.FC = () => (
  <div className="theme-marketing-brand relative min-h-screen flex flex-col bg-[var(--bg-canvas)] text-[var(--text-primary)]">
    <ModernNavbar />
    <main className="flex-1">
      <Outlet />
    </main>
    <Suspense fallback={null}>
      <ModernFooter />
    </Suspense>
  </div>
)

export default PublicLayout
